import axios from "axios";
import { baseURL } from "../config";
import { dataService } from "./data.services";
import { getAuthItem } from "../CommonMethods/authSession";


async function verifyPreference(payload) {
    // const idToken = localStorage.getItem("IdToken");
    // const headers = {
    //     Authorization: `Bearer ${idToken}`,
    // };
    const idToken = getAuthItem("IdToken");
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    try {
        const data = await axios.post(`${baseURL}patients/add-preference`, payload,{
            headers: headers,
        });
        return {error: false, data: data.data};
    } catch (error) {
        return {error: true, message: error};
    }
}
async function login(email, password,browserId) {
    let payload = {
        user_name: email,
        password: password,
        browser_id: browserId.toString(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    try {
        const data = await axios.post(`${baseURL}patients/login`, payload);
        return {error: false, data: data.data};
    } catch (error) {
        return {error: true, message: error};
    }
}

async function resetPassword(endpoint,payload) {
    //payload = JSON.stringify(payload);
    const idToken = getAuthItem("IdToken");
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    try {
        const data = await axios.patch(`${baseURL}${endpoint}`, payload,{
            headers: headers,
        });
        return {error: false, data: data};
    } catch (error) {
        return {error: true, message: error};
    }
}

async function verifyOtp(payload) {
    const idToken = getAuthItem("IdToken");
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    try {
        const data = await axios.post(`${baseURL}patients/preference`, payload,{
            headers: headers,
        });
        return {error: false, data: data.data};
    } catch (error) {
        return {error: true, message: error};
    }
}
async function preferenceList() {
    const idToken = getAuthItem("IdToken");
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    try {
        const data = await axios.get(`${baseURL}patients/preference`,{
            headers: headers,
        });
        return {error: false, data: data.data};
    } catch (error) {
        return {error: true, message: error};
    }
}

async function getCountryCodes() {
    
    // payload = JSON.stringify(payload);
    try {
        const data = await axios.get('https://restcountries.com/v2/all?fields=name,alpha3Code,callingCodes');
        return {error: false, data: data.data};
    } catch (error) {
        return {error: true, message: error};
    }
}

async function forgotPassword(email, payload) {
    // payload = JSON.stringify(payload);
    try {
        const data = await axios.post(`${baseURL}${email}`, payload);
        return {error: false, data: data.data};
    } catch (error) {
        return {error: true, message: error};
    }
}



async function sendOtptoPreference(preference_id) {
    const sessionToken = getAuthItem("session_token");
    let payload = {
        session_token: sessionToken,
        preference_id: preference_id,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    try {
        const data = await axios.post(`${baseURL}patients/login/send-otp`, payload);
        return {error: false, data: data.data};
    } catch (error) {
        return {error: true, message: error};
    }
}

async function verifyLoginOtp(otp) {
    const sessionToken = getAuthItem("verify_otp_session_token");
    let payload = {
        session_token: sessionToken,
        otp: otp,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    try {
        const data = await axios.post(`${baseURL}patients/login/verify-otp`, payload);
        return {error: false, data: data.data};
    } catch (error) {
        return {error: true, message: error};
    
    }
}

async function RefreshToken() {
    const idToken = getAuthItem("IdToken");
    const refreshToken = getAuthItem("RefreshToken");
    const body = {
        refresh_token: refreshToken,
        user_type:getAuthItem('user_type')
    }
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    try {
        const data = await axios.post(`${baseURL}patients/refresh-token`, body ,{
            headers: headers,
        });
        return {error: false, data: data.data};
    } catch (error) {
        //sessionStorage.setItem('custom-status', 'inactive');
        return {error: true, message: error};
    }
}

async function resendOtp(preference_id) {
    const sessionToken = getAuthItem("session_token");
    let payload = {
        session_token: sessionToken,
        preference_id: preference_id,
        type: "resend-otp",
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    try {
        const data = await axios.post(`${baseURL}patients/login/send-otp`, payload);
        return {error: false, data: data.data};
    } catch (error) {
        return {error: true, message: error};
    
    }
}

async function logout() {
    const idToken = getAuthItem("IdToken");
    // const accessToken = sessionStorage.getItem("AccessToken");
    const refreshToken = getAuthItem('RefreshToken')

    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    let payload = {
        "token" : refreshToken,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        
    }
    try {
        const data = await axios.post(`${baseURL}patients/logout`,payload,{
            headers: headers,
        });
        return {error: false, data: data.data};
    } catch (error) {
        return {error: true, message: error};
    }
}

async function getUserData() {
    
    // payload = JSON.stringify(payload);
    try {
        const data = await dataService.GetAPI('patients/check-status');
        return {error: false, data: data};
    } catch (error) {
        return {error: true, message: error};
    }
}


async function deletePreference(_id) {
    const idToken = getAuthItem("IdToken");
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    try {
        const data = await axios.delete(`${baseURL}patients/preference/${_id}`,{
            headers: headers,
        });
        return {error: false, data: data.data};
    } catch (error) {
        return {error: true, message: error};
    }
}

async function trustMyBrowser(body) {
    const idToken = getAuthItem("IdToken");
    const id = getAuthItem("id");
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    try {
        const data = await axios.patch(`${baseURL}patients/trust-browser/${id}?user_type=${getAuthItem('user_type')==='patient-user'?'patient':'observer'}`,body,{
            headers: headers,
        });
        return {error: false, data: data.data};
    } catch (error) {
        return {error: true, message: error};
    }
}
// get help guide
async function getHelpGuideLogin() {
    
    // payload = JSON.stringify(payload);
    try {
        const data = await dataService.GetAPI('help-guide-login?type=patients-login');
        return {error: false, data: data};
    } catch (error) {
        return {error: true, message: error};
    }
}
async function DuplicateTabClose() {
    const idToken = getAuthItem('IdToken');
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    let payload = {
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    }
    try {
        const data = await axios.post(`${baseURL}users/clear-session`,payload,{
            headers: headers,
        });
        return {error: false, data: data.data};
    } catch (error) {
        return {error: true, message: error};
    }
}

async function DuplicateLogout() {
    const idToken = getAuthItem('IdToken')
    const refreshToken = getAuthItem('RefreshToken')
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    let payload = {
        "token" : refreshToken,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    }
    try {
        const data = await axios.post(`${baseURL}patients/logout?type=clear-session`,payload,{
            headers: headers,
        });
        return {error: false, data: data.data};
    } catch (error) {
        return {error: true, message: error};
    }
}

async function CancelDuplicatelogin() {
    let payload = {
        user_name: getAuthItem('email'),
        user_type:getAuthItem('user_type')==="patient-user" ? "patient" : "observer",
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    try {
        const data = await axios.post(`${baseURL}users/capture-log`, payload);
        return {error: false, data: data.data};
    } catch (error) {
        return {error: true, message: error};
    }
}


export const userService = {
    getCountryCodes,
    forgotPassword,
    login,
    verifyPreference,
    verifyOtp,
    resetPassword,
    preferenceList,
    resendOtp,
    RefreshToken,
    verifyLoginOtp,
    sendOtptoPreference,
    logout,
    getUserData,
    deletePreference,
    trustMyBrowser,
    getHelpGuideLogin,
    DuplicateTabClose,
    DuplicateLogout,
    CancelDuplicatelogin,

}
